/**
 * The settings for all default Candy Machine guards.
 */

/**
 * The mint settings for all default Candy Machine guards.
 */

/**
 * The mint settings for all default Candy Machine guards.
 */

/** @internal */
const defaultCandyGuardNames = ['botTax', 'solPayment', 'tokenPayment', 'startDate', 'thirdPartySigner', 'tokenGate', 'gatekeeper', 'endDate', 'allowList', 'mintLimit', 'nftPayment', 'redeemedAmount', 'addressGate', 'nftGate', 'nftBurn', 'tokenBurn', 'freezeSolPayment', 'freezeTokenPayment', 'programGate'];

/** @internal */
const emptyDefaultCandyGuardSettings = defaultCandyGuardNames.reduce((acc, name) => {
  acc[name] = null;
  return acc;
}, {});

export { defaultCandyGuardNames, emptyDefaultCandyGuardSettings };
//# sourceMappingURL=default.mjs.map
